<template>
  <div>
    <el-button class="base-margin__bottom-10" type="primary" @click="openDialog">{{
        $t('ipManagement.createWhitelist')
      }}
    </el-button>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('ipManagement.id')" prop="id" width="100"></el-table-column>
        <el-table-column :label="$t('ipManagement.projectId')" prop="projectId">
          <template slot-scope="scope">
            <span>{{ scope.row.projectId === 0 ? $t('ipManagement.all') : scope.row.projectId }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('ipManagement.whitelistType')">
          <template slot-scope="scope">
            <span>{{ filterAllowType(scope.row.allowType) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('ipManagement.whitelistContent')" prop="allowValue"></el-table-column>
        <el-table-column :label="$t('ipManagement.whitelistUser')">
          <template slot-scope="scope">
            {{ filterUserName(scope.row.userId) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('ipManagement.remark')" prop="describe"></el-table-column>
        <el-table-column :label="$t('ipManagement.createTime')" prop="createTime" width="220"></el-table-column>
        <el-table-column
          :label="$t('ipManagement.actions')"
          width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editImage(scope.row)">{{ $t('ipManagement.edit') }}</el-button>
            <el-button type="text" @click="deleteImage(scope.row.id)">{{ $t('ipManagement.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="520px"
    >
      <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="100px">
        <el-form-item :label="$t('ipManagement.whitelistProject')" prop="projectId">
          <el-select v-model="formLabelAlign.projectId" :placeholder="$t('ipManagement.selectWhitelistProject')">
            <el-option
              v-for="item in projectOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ipManagement.whitelistUser')" prop="userId">
          <el-select v-model="formLabelAlign.userId" :placeholder="$t('ipManagement.selectWhitelistUser')">
            <el-option
              v-for="item in userList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ipManagement.whitelistType')" prop="allowType">
          <el-select v-model="formLabelAlign.allowType" :placeholder="$t('ipManagement.selectWhitelistType')">
            <el-option
              v-for="item in allowTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('ipManagement.whitelist')" prop="allowValue">
          <el-input v-model="formLabelAlign.allowValue"
                    :placeholder="$t('ipManagement.enterWhitelistContent')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ipManagement.remark')" prop="describe">
          <el-input v-model="formLabelAlign.describe" rows="5" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="createCode">{{ $t('ipManagement.confirm') }}</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {Message} from 'element-ui';
import {debounce} from '@/common/utils/utils';

export default {
  name: 'mirrorManagement',
  data() {
    return {
      tableData: [], // 白名单列表
      dialogTitle: this.$t('ipManagement.createWhitelist'),
      dialogVisible: false,
      projectOptions: [{
        value: 0,
        label: this.$t('ipManagement.all'),
      }],
      allowTypeOptions: [{
        value: 1,
        label: this.$t('ipManagement.prometheusReport'),
      },
        {
          value: 2,
          label: this.$t('ipManagement.otherReport'),
        },
        {
          value: 3,
          label: this.$t('ipManagement.mirrorWhitelist'),
        }],
      formLabelAlign: {
        allowValue: '',
        projectId: '',
        allowType: '',
        describe: '',
        userId: null,
      },
      dialogType: 'add',
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      userList: [],
    };
  },
  created() {
    this.getList();
    this.getUserList();
  },

  methods: {
    openDialog() {
      this.dialogTitle = this.$t('ipManagement.createWhitelist');
      this.dialogType = 'add';
      this.formLabelAlign = {
        allowValue: '',
        projectId: '',
        allowType: '',
        describe: '',
      };
      this.dialogVisible = true;
    },

    /**
     * 获取白名单列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/admin/getAccessList?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.tableData = res.list;
        this.tableDataTotal = res.total;
      });
    },

    /**
     * 创建白名单
     */
    createCode() {
      this.formLabelAlign.projectId = +this.formLabelAlign.projectId;
      debounce(() => {
        if (this.dialogType === 'add') {
          postRequest('/api/eda/common/admin/createAccess', this.formLabelAlign).then(() => {
            Message.success(this.$t('ipManagement.createSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        } else {
          postRequest('/api/eda/common/admin/updateAccess', this.formLabelAlign).then(() => {
            Message.success(this.$t('ipManagement.updateSuccess'));
            this.dialogVisible = false;
            this.getList();
          });
        }
      }, 500);
    },

    /**
     * 编辑白名单
     */
    editImage(e) {
      this.dialogTitle = this.$t('ipManagement.editWhitelist');
      this.dialogType = 'edit';
      this.formLabelAlign = Object.assign({}, e);
      this.dialogVisible = true;
    },

    /**
     * 删除白名单
     */
    deleteImage(id) {
      this.$confirm(this.$t('ipManagement.deleteConfirm'), this.$t('ipManagement.deleteWhitelist'), {
        confirmButtonText: this.$t('ipManagement.confirm'),
      }).then(() => {
        postRequest('/api/eda/common/admin/deleteAccess', {id: +id}).then(() => {
          this.getList();
          Message.success(this.$t('ipManagement.deleteSuccess'));
        });
      })
        .catch(() => {
          // Message.info('取消删除');
        });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },

    /**
     * 获取用户列表
     */
    getUserList() {
      getRequest('/api/eda/common/admin/getUserList?offset=0&limit=999').then((res) => {
        this.userList = res.list;
      });
    },
    /**
     * 筛选用户名称
     */
    filterUserName(id) {
      let name = '';
      if (id === 0 || id === '') {
        name = '-';
      } else {
        name = this.userList.filter(item => item.id === +id)[0]?.name;
      }
      return name;
    },
    /**
     * 筛选
     */
    filterAllowType(id) {
      return this.allowTypeOptions.filter(item => item.value === +id)[0].label;
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.spanCls {
  width: 50px;
  line-height: 40px;
}
</style>
